var React = require('react');

function Ga (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#ffe700","d":"M640 480H0V0h640z","key":0}),React.createElement("path",{"fill":"#36a100","d":"M640 160H0V0h640z","key":1}),React.createElement("path",{"fill":"#006dbc","d":"M640 480H0V320h640z","key":2})]));
}

Ga.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ga;

Ga.default = Ga;
